import type { QuickBooksCustomer } from "@/lib/types/quickbooks-unified";

export async function fetchQuickBooksCustomerData(
  qbRefs: Array<{ customerId: string; realmId?: string }>,
  accessToken: string
): Promise<QuickBooksCustomer[]> {
  const promises = qbRefs.map(async ({ customerId, realmId }) => {
    const queryParams = new URLSearchParams({
      entityType: "customer",
      customerId,
      ...(realmId && { realmId }),
    });

    const response = await fetch(`/api/quickbooks/entities?${queryParams.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      console.warn(`Failed to fetch QB customer ${customerId}:`, response.status);
      return null;
    }

    const customerData = await response.json();
    return { ...customerData, realmId };
  });

  const results = await Promise.all(promises);
  return results.filter(Boolean) as QuickBooksCustomer[];
}
